import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';
import CaseCreationPaymentInformation from '../../CaseCreation/PaymentInformation/PaymentInformation';
import PaymentInformation from './PaymentInformation';

const PaymentInformationValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
      component = <PaymentInformation />;
      break;
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor: {
      const roleName = user.userInfo.role.name;
      component = isUnifiedStaffCaseIntakeRole(roleName) ? (
        <CaseCreationPaymentInformation />
      ) : (
        <PaymentInformation />
      );
      break;
    }
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin: {
      const roleName = user.userInfo.role.name;
      component = isUnifiedStaffCaseIntakeRole(roleName) ? (
        <CaseCreationPaymentInformation />
      ) : (
        <PaymentInformation />
      );
      break;
    }
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default PaymentInformationValidation;
